import { Link } from "react-router-dom";

import { Icon, Popup } from "semantic-ui-react";

import type { OpenAPI } from "simplydo/interfaces";
import { MSTeamsIcon } from "simplydo/react/components/Branding/MSTeams";

import { useAppSelector } from "store";

import { socialMediaLinks } from "components/users/Details/ProfileLink";

type SocialLinksProps = {
  user: OpenAPI.Assign<
    OpenAPI.Schemas["User"],
    OpenAPI.Schemas["AssignUserPrepare"]
  >;
};

export const SocialLinks = ({ user, compact = false }: SocialLinksProps) => {
  const currentUser = useAppSelector((state) => state.user);

  const hasProfile = user?.profile;
  if (!hasProfile) {
    user = { profile: { fullName: "Unknown User" } };
  }

  const org = currentUser?.ownerOrganisation;

  const profileSocialElements =
    hasProfile ?
      [
        "linkedin",
        "website",
        "facebook",
        "instagram",
        "github",
        "twitter",
      ].filter((key) => !!user?.profile[key])
    : [];

  const teamsHandle = user?.teamsHandle;
  const canMessageViaTeams =
    !!currentUser?.ownerOrganisation?.enabledFeatures?.includes(
      "teamsHandleAdvertising",
    ) && !!teamsHandle;

  return (
    <div
      style={{ display: "inline-flex", alignItems: "center", marginLeft: 5 }}
    >
      {!user?.profile?.linkedin &&
        currentUser._id === user._id &&
        org?.superadminTags?.innovationType === "externalInnovation" && (
          <Popup
            offset={[-10, 2]}
            content={<p>Add your LinkedIn</p>}
            trigger={
              <Link
                to="/preferences/profile"
                onClick={(e) => e.stopPropagation()}
              >
                <Icon
                  name="linkedin"
                  style={{
                    marginLeft: "4px",
                    marginBottom: "2px",
                    color: "#8a8e90ff",
                  }}
                />
              </Link>
            }
          />
        )}

      {profileSocialElements.map((socialElement) => {
        const link = user?.profile[socialElement];
        if (!link) return null;
        const fullLink =
          link.startsWith("https://") || link.startsWith("www.") ?
            link
          : socialMediaLinks[socialElement].link + link;

        return (
          <a
            key={socialElement}
            href={fullLink}
            target="blank"
            onClick={(e) => e.stopPropagation()}
            rel="noreferrer noopenner"
          >
            {socialMediaLinks[socialElement].icon && (
              <Icon
                style={{ color: socialMediaLinks[socialElement].color }}
                name={socialMediaLinks[socialElement].icon}
              />
            )}
            {socialMediaLinks[socialElement].iconLeftAlt && (
              <span
                style={{
                  fontSize: "1.15em",
                  color: "black",
                  padding: "0 0.1em",
                }}
              >
                {socialMediaLinks[socialElement].iconLeftAlt}
              </span>
            )}
          </a>
        );
      })}
      {canMessageViaTeams ?
        <Popup
          content={<p>Message via Teams</p>}
          offset={[-12, 4]}
          trigger={
            <a
              key="teams"
              href={`https://teams.microsoft.com/l/chat/0/0?users=${encodeURIComponent(teamsHandle)}`}
              target="blank"
              onClick={(e) => e.stopPropagation()}
              rel="noreferrer noopenner"
            >
              <MSTeamsIcon
                style={{ marginRight: 5, marginBottom: compact ? -2 : -3 }}
                size={compact ? 13 : 22}
                color="#6264A7"
              />
            </a>
          }
        />
      : null}
    </div>
  );
};
